module.exports = __webpack_public_path__ + "media/images/riders/GREG_MINNAAR-451fb7eeb22a293942b47791a0dd4e4d.png";